import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { GET } from '../service/base-api-service';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchGasSensorExpiryLog = createAsyncThunk(
  'gasSensorExpiry/fetchByChamberAndDevice',
  async ({ chamberId, deviceType }, { rejectWithValue }) => {
    try {
      return await GET(`v1/report/dashboard/chambers/${chamberId}/gas-sensor-expiry`, {
        params: { deviceType },
      });
    } catch (error) {
      const message =
        error?.data?.message ||
        error?.message ||
        'Failed to load gas sensor expiry data.';
      return rejectWithValue(message);
    }
  },
);

const gasSensorExpirySlice = createSlice({
  name: 'gasSensorExpiry',
  initialState,
  reducers: {
    clearGasSensorExpiry: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: {
    [fetchGasSensorExpiryLog.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [fetchGasSensorExpiryLog.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload || null;
      state.error = null;
    },
    [fetchGasSensorExpiryLog.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to load gas sensor expiry data.';
    },
  },
});

export const { clearGasSensorExpiry } = gasSensorExpirySlice.actions;

const getGasSensorExpiryStore = (state) => state.gasSensorExpiry;

export const getGasSensorExpiryData = createSelector(getGasSensorExpiryStore, (state) => state.data);
export const getGasSensorExpiryLoading = createSelector(getGasSensorExpiryStore, (state) => state.loading);
export const getGasSensorExpiryError = createSelector(getGasSensorExpiryStore, (state) => state.error);

export default gasSensorExpirySlice.reducer;
